import React from 'react';
import logo from '../../logo_bb.svg';

export const contextControlMarkup = (
  <div className="ContextControl">
    <img height={40} src={logo} />
  </div>
);
